import { render, staticRenderFns } from "./OrgUnknownSMS.vue?vue&type=template&id=56cb7bec&scoped=true&"
import script from "./OrgUnknownSMS.vue?vue&type=script&lang=js&"
export * from "./OrgUnknownSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb7bec",
  null
  
)

export default component.exports